import { useQuery } from '@apollo/client'
import { getEmailRecordList as getEmailRecordListGql }
   from 'src/graphql/queries/getEmailRecordList.gql'

const useEmailRecordList = (variables, options) => {
   let timezoneId = null
   try {
      timezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
   } catch (err) {
      // API will do some magic if we don't pass a timezone
   }

   const { data, ...otherQueryReturnValues } = useQuery(getEmailRecordListGql, {
      variables: { timezoneId, ...variables },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...options
   })

   return {
      ...otherQueryReturnValues,
      emailRecordList: data
         ? data.emailRecordList
         : { items: [], listInfo: {} }
   }
}

export default useEmailRecordList
